import { render, staticRenderFns } from "./CytomineTable.vue?vue&type=template&id=3facf4dd&scoped=true"
import script from "./CytomineTable.vue?vue&type=script&lang=js"
export * from "./CytomineTable.vue?vue&type=script&lang=js"
import style0 from "./CytomineTable.vue?vue&type=style&index=0&id=3facf4dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3facf4dd",
  null
  
)

export default component.exports